export default __webpack_public_path__ + "static/mar-call-center-omnichannel-727c6792d1159518a5884962b5790211.png";